import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-order-form-recount-confirm',
  templateUrl: './order-form-recount-confirm.component.html',
  styleUrls: ['./order-form-recount-confirm.component.scss']
})
export class OrderFormRecountConfirmComponent implements OnInit {

  constructor(@Inject( MAT_DIALOG_DATA ) public data: any,
              public dialogRef: MatDialogRef<OrderFormRecountConfirmComponent>,
              private cd: ChangeDetectorRef) { }

  ngOnInit () {
    this.cd.detectChanges();
  }

  close () {
    this.dialogRef.close( false );
  }

  save () {
    this.dialogRef.close( true );
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/order-form-recount-confirm/order-form-recount-confirm.component.ts